import moment, { Moment } from 'moment'
import { language_w } from 'src/backend-codes'
import i18n from 'src/i18n'
import { address_t, dict, opt, option_t } from 'src/types'

export const is_sm = window.innerWidth >= 576
export const is_md = window.innerWidth >= 768
export const is_lg = window.innerWidth >= 992
export const is_xl = window.innerWidth >= 1200

export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const get_language = (): language_w => {
  return i18n?.language?.split('-')[0]?.toUpperCase() as language_w
}

export const is_valorized = (value: unknown): boolean => {
  return value !== null && value !== undefined
}

export const is_obj_empty = (value: unknown): boolean => {
  return JSON.stringify(value) === '{}'
}

export const is_obj_full = (value: unknown): boolean => {
  return !!value && JSON.stringify(value) !== '{}'
}

export const deep_copy = <T>(item: T): T => {
  return JSON.parse(JSON.stringify(item))
}

export const deep_cmp = <T>(item_1: T, item_2: T): boolean => {
  return JSON.stringify(item_1) === JSON.stringify(item_2)
}

export const insensitive_substr = (str: string, substr: string): boolean => {
  return !!str?.toLowerCase()?.includes(substr?.toLowerCase())
}

export const insensitive_compare = (s1: string, s2: string): boolean => {
  return s1?.toLowerCase() === s2?.toLowerCase()
}

export const insensitive_include = (strs: string[], str: string): boolean => {
  return !!strs?.find((s) => insensitive_compare(s, str))
}

export const find_option = (options?: option_t[], key?: string): opt<option_t> => {
  return options?.find((o) => o?.key === key)
}

export const compare_dates = (d1?: Date, d2?: Date): number => {
  if (!d1 || !d2 || isNaN(d1?.getTime()) || isNaN(d2?.getTime())) {
    return -2
  }
  if (moment(d1).format('DD/MM/YYYY') === moment(d2).format('DD/MM/YYYY')) {
    return 0
  }
  return d1 < d2 ? -1 : 1
}

export const to_address = (address: string): address_t => {
  const addr_fields = address.split(',')
  const cap_fields = addr_fields[2].trim().split(' ')

  const cap = cap_fields?.[0].trim()
  const province = cap_fields?.[cap_fields.length - 1].trim()
  const city = addr_fields[2].replace(cap, '').replace(province, '').trim()

  return {
    street: addr_fields[0],
    civic_numer: addr_fields[1].trim(),
    cap,
    province,
    city,
  }
}

export const extract_birth_date = (cf?: string): string => {
  // Day
  let DD_ = Number(cf?.slice(9, 11))
  if (DD_ > 31) DD_ -= 40
  const DD = ('0' + DD_).slice(-2)

  // Month
  const to_month: dict = {
    A: '01',
    B: '02',
    C: '03',
    D: '04',
    E: '05',
    H: '06',
    L: '07',
    M: '08',
    P: '09',
    R: '10',
    S: '11',
    T: '12',
  }
  const MM = to_month[cf?.[8] || '']

  // Year
  let YYYY = Number(cf?.slice(6, 8))
  if (YYYY + 2000 > new Date().getFullYear()) {
    YYYY += 1900
  } else {
    YYYY += 2000
  }

  return `${DD}/${MM}/${YYYY}`
}

export const round_with_2_decimals = (x: number): number => Math.round(x * 100) / 100

export const diff_years = (date_end: Moment, date_start: Moment = moment()): number => {
  return round_with_2_decimals(date_start.diff(date_end, 'years', true))
}

export const mop_2_ruote_categories = [
  'CICLOMOTORE NOLEGGIO LIBERO',
  'CICLOMOTORE USO PRIVATO',
  'CICLOMOTORE SCUOLA GUIDA',
  'MOTOCICLO USO PRIVATO',
  'MOTOCICLO NOLEGGIO LIBERO',
  'MOTOCICLO SCUOLA GUIDA',
  '01-30-0-5',
  '04-30-0-5',
  '26-30-0-5',
  '01-31-0-5',
  '04-31-0-5',
  '26-31-0-5',
]

export const get_birth_date_disabled_from = (): string => {
  const today = new Date()
  const d = new Date(today)
  d.setFullYear(d.getFullYear() - 18)

  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()

  return `${day}/${month}/${year}`
}
